"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullCount = exports.fullAssign = void 0;
const lodash_1 = require("lodash");
const types_1 = require("./types");
function fullAssign(source, callback) {
    let objKeys = Array.isArray(source) ? source : Object.keys(source);
    const proxy = new Proxy({}, {
        get(target) { return target; },
        set(target, prop, value) {
            target[prop] = value;
            let resolve = true;
            for (let key of objKeys) {
                if (types_1.isNegateEmpty(target[key])) {
                    resolve = false;
                    break;
                }
            }
            if (resolve) {
                callback(target);
                objKeys.forEach(key => Reflect.deleteProperty(target, key));
            }
            return true;
        }
    });
    return proxy;
}
exports.fullAssign = fullAssign;
function fullCount(end, callback) {
    let callbackParams = [];
    const proxy = new Proxy({ count: 0 }, {
        set(target, prop, value) {
            target[prop] = value;
            if (target.count >= end) {
                callback(lodash_1.tail(callbackParams), callbackParams);
                target.count = 0;
                callbackParams = [];
            }
            return true;
        }
    });
    return (params) => {
        callbackParams.push(params);
        return proxy.count += 1;
    };
}
exports.fullCount = fullCount;
